import React from 'react';
import globalGetPadding from '../../utils/getPadding';
import { getFontSize } from '../../utils/commonFun';

function getFontFamily(fontFamily) {
    switch (fontFamily) {
        case 'MODERN_SANS':
            return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
        case 'BOOK_SANS':
            return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
        case 'ORGANIC_SANS':
            return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
        case 'GEOMETRIC_SANS':
            return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
        case 'HEAVY_SANS':
            return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
        case 'ROUNDED_SANS':
            return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
        case 'MODERN_SERIF':
            return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
        case 'BOOK_SERIF':
            return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
        case 'MONOSPACE':
            return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
    }
    return undefined;
}

function getRoundedCorners(props) {
    const buttonStyle = props?.buttonStyle ?? '';

    switch (buttonStyle) {
        case 'rectangle':
            return undefined;
        case 'pill':
            return 64;
        case 'rounded':
        default:
            return 4;
    }
}

function getButtonSizePadding(props) {
    const size = props?.size ?? '';
    switch (size) {
        case 'x-small':
            return [4, 8];
        case 'small':
            return [8, 12];
        case 'large':
            return [16, 32];
        case 'medium':
        default:
            return [12, 20];
    }
}

export function CustomButton({ style, props, formClientWidth }) {
    const text = props?.text ?? '';
    const url = props?.url ?? '';
    const fullWidth = props?.fullWidth ?? 'block';
    const buttonTextColor = props?.buttonTextColor ?? undefined;
    const buttonBackgroundColor = props?.buttonBackgroundColor ?? undefined;
    const isMobile = formClientWidth <= 480;

    const padding = getButtonSizePadding(props);
    const wrapperStyle = {
        backgroundColor: style?.backgroundColor ?? undefined,
        textAlign: style?.textAlign ?? undefined,
        padding: globalGetPadding(style?.padding, isMobile),
    };
    const linkStyle = {
        color: buttonTextColor,
        fontSize: getFontSize(style?.fontSize, isMobile),
        fontFamily: getFontFamily(style?.fontFamily),
        fontWeight: style?.fontWeight ?? 'bold',
        backgroundColor: buttonBackgroundColor,
        borderRadius: getRoundedCorners(props),
        display: fullWidth ? 'block' : 'inline-block',
        padding: `${padding[0]}px ${padding[1]}px`,
        textDecoration: 'none',
    };

    return (
        <div style={wrapperStyle}>
            <a href={url} style={linkStyle} target="_blank">
                <span>{text}</span>
            </a>
        </div>
    );
}
